import * as R from 'remeda';
import equal from 'fast-deep-equal/es6/react';
import { createSelectorCreator, lruMemoize } from 'reselect';

const createDeepEqualSelector = createSelectorCreator(lruMemoize, (a, b) =>
  a || b === null ? R.isDeepEqual(a, b) : equal(a, b)
);

export default createDeepEqualSelector;
